import { isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LazyLoadStyleService {
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly loadedStyles = new Set<string>();

  loadOwlCarousel(): void {
    this.loadNonCritical('/owl-carousel-18.css');
  }

  private loadNonCritical(url: string): void {
    if (isPlatformServer(this.platformId) || this.loadedStyles.has(url)) {
      return;
    }

    const link = this.document.createElement('link');
    link.href = url;
    link.rel = 'preload';
    link.as = 'style';
    link.onload = () => {
      link.onload = null;
      link.rel = 'stylesheet';
    };

    this.document.head.appendChild(link);
    this.loadedStyles.add(url);
  }
}
